import {
  CHOOSE_TEMPLATE_MODAL_MAX_HEIGHT,
  CHOOSE_TEMPLATE_MODAL_MAX_WIDTH,
  MODAL_VIEWPORT_MARGIN,
} from '../../../../constants/templates';

export const warningAlertStyle = {
  mx: 3.75,
  mt: 2.5,
  flexShrink: 0,
};

export const filtersContainerStyle = {
  mx: 3.75,
  mb: 2.5,
  mt: 2.5,
  flexShrink: 0,
};

export const contentStyle = {
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

export const dialogContentStyles = {
  p: 0,
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
};

export const dialogPaperStyles = {
  '& .MuiDialog-paper': {
    // Clamp to the max size, then to the viewport minus the standard dialog margins.
    width: `min(${CHOOSE_TEMPLATE_MODAL_MAX_WIDTH}px, 100vw - ${MODAL_VIEWPORT_MARGIN}px)`,
    height: `min(${CHOOSE_TEMPLATE_MODAL_MAX_HEIGHT}px, 100vh - ${MODAL_VIEWPORT_MARGIN}px)`,
    maxWidth: 'none',
    maxHeight: 'none',
    m: 0,
    display: 'flex',
    flexDirection: 'column',
  },
};
